<div class="container">
  <ix-icon name="lock-filled" size="32"></ix-icon>
  <ix-typography class="text-item" format="h3">Access denied</ix-typography>
  <ix-typography class="text-item">You don't have permission to access this page.</ix-typography>
</div>
